import { Button, InputAdornment, makeStyles, TextField } from '@material-ui/core';
import { FolderOpen } from '@material-ui/icons';
import PublishIcon from '@material-ui/icons/Publish';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  textFieldInput: {
    '& .MuiInputBase-input': {
      color: theme.palette.text.primary,
    },

    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.error.main,
    },
  },
}));

type BidsUploadFormProps = {
  onSubmit: () => void;
};

const SpotdealsAllmobilUploadForm = ({ onSubmit }: BidsUploadFormProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext();
  const file = watch('file');
  const fileName = file && file[0] ? file[0].name.replace('C:\\fakepath\\', '') : '';

  return (
    <form onSubmit={onSubmit}>
      <input id="file" accept="text/xlsx" type="file" {...register('file', { required: true })} hidden />
      <TextField
        fullWidth
        label={t('carsTable.excelFile')}
        margin="dense"
        variant="outlined"
        value={fileName}
        disabled
        error={!!errors.file}
        InputLabelProps={{
          disabled: false,
        }}
        InputProps={{
          className: classes.textFieldInput,
          endAdornment: (
            <InputAdornment position="end">
              <Button component="label" htmlFor="file" endIcon={<FolderOpen />}>
                {t('common.chooseFile')}
              </Button>
            </InputAdornment>
          ),
        }}
      />

      <Button endIcon={<PublishIcon />} type="submit" variant="contained" color="primary">
        {t('common.upload')}
      </Button>
    </form>
  );
};

export default SpotdealsAllmobilUploadForm;
